// Return exact outcomes so a partial failure never clears a user's failed selection.
export async function deleteContactRecords(api, ids, request = fetch) {
  const results = await Promise.allSettled(ids.map(id => request(`${api}/contacts/${id}`, { method: 'DELETE' })));
  return results.reduce((outcome, result, index) => {
    outcome[result.status === 'fulfilled' && result.value.ok ? 'deletedIds' : 'failedIds'].push(ids[index]);
    return outcome;
  }, { deletedIds: [], failedIds: [] });
}
